import * as type from '../mutation-types'
const R = require('ramda')
export const fahrzeugStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      alleFahrzeuge: 'fahrzeug/all',
      repairMyCar: 'fahrzeug/repair',
      byNewCar: 'fahrzeug/byNewCar'
    },
    imageURL: '/static/game/fahrzeuge/',
    fahrzeug: {},
    ausbau: {
      inBau: false, // wurde neues Fahrzeug gekauft
      currentVal: 0,
      fahrzeug: {}
    },
    fahrzeuge: {},
    cacheTime: 0 // in sec
  },
  mutations: {
    [type.FAHRZEUG_RESET] (state) {
      state.fahrzeug = {}
      state.ausbau = {
        inBau: false,
        currentVal: 0,
        fahrzeug: {}
      }
      state.fahrzeuge = {}
      state.cacheTime = 0
    },
    [type.FAHRZEUG_SET_FAHRZEUGE] (state, data) {
      state.fahrzeuge = data
    },
    [type.FAHRZEUG_SET_MY_FAHRZEUG] (state, data) {
      state.fahrzeug = data
    },
    [type.FAHRZEUG_SET_ZUSTAND] (state, data) {
      state.fahrzeug.zustand = data
    },
    [type.FAHRZEUG_SET_CACHE_TIME] (state) {
      state.cacheTime = Math.floor(new Date().getTime() / 1000)
    },
    [type.FAHRZEUG_SET_AUSBAU] (state, data) {
      state.ausbau.inBau = data.fahrzeugInBau
      state.ausbau.fahrzeug = data.fahrzeug
      state.ausbau.currentVal = data.fahrzeugCurrentVal
    }
  },
  getters: {
    allFahrzeugeUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.alleFahrzeuge
    },
    repairMyCarUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.repairMyCar
    },
    byNewCarUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.byNewCar
    },
    getCurrentRepairCost: (state) => {
      return Math.ceil(state.fahrzeug.kosten * state.fahrzeug.repair_cost)
    },
    ausbauStatus: (state) => {
      if (R.isNil(state.ausbau.fahrzeug) || R.isNil(state.ausbau.fahrzeug.dauer)) {
        return 0
      }
      return Math.ceil((state.ausbau.currentVal * 100) / (state.ausbau.fahrzeug.dauer || 1))
    },
    ausbauStatusText: (state) => {
      const tage = (state.ausbau.fahrzeug.dauer || 0) - state.ausbau.currentVal
      let spieltag = ' Spieltage'
      if (tage === 1) {
        spieltag = ' Spieltag'
      }
      return 'Verbleibende Tage bis Fertigstellung: ' + tage + spieltag
    }
  },
  actions: {
    async byNewCar ({ commit, getters, dispatch }, carId) {
      // set transport options
      const transportOptions = {
        data: { carId: carId },
        url: getters.byNewCarUrl
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set ausbau
        commit(type.FAHRZEUG_SET_AUSBAU, response.data.ausbau)
        // set new money
        commit('moneyStore/MONEY_SET_GIRO', response.data.giro, { root: true })
        commit(type.ROOT_SET_SNACKBAR, 'Glückwunsch, Du hast Dir ein neues Fahrzeug gekauft', { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // login an user
    async getAllFahrzeuge ({ state, commit, getters, dispatch, rootState }) {
      // checkif cache is valid
      const currentTime = Math.floor(new Date().getTime() / 1000) // in sec
      if (state.fahrzeuge.length > 0 && currentTime < (state.cacheTime + rootState.cacheTimeout)) {
        return true
      }
      // console.log('cache false')
      // set transport options
      const transportOptions = {
        method: 'get',
        data: { fakeData: true },
        url: getters.allFahrzeugeUrl,
        withoutAuth: true
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        commit(type.FAHRZEUG_SET_FAHRZEUGE, response.data.fahrzeuge)
        commit(type.FAHRZEUG_SET_CACHE_TIME)
      } else {
        ret = false
      }

      return ret
    },
    // login an user
    async repairMyCar ({ state, commit, getters, dispatch, rootState }) {
      // set transport options
      const transportOptions = {
        data: { fakeData: true },
        url: getters.repairMyCarUrl
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set new zustand
        commit(type.FAHRZEUG_SET_ZUSTAND, response.data.zustand)
        // set new money
        commit('moneyStore/MONEY_SET_GIRO', response.data.giro, { root: true })
      } else {
        ret = false
      }

      return ret
    }
  }
}
